const TipoCadastroCorpoClinicoOptions = [
  { id: 1, text: "Médico Corpo Clínico Aberto", value:"MedicoCorpoClinicoAberto" },
  { id: 2, text: "Médico Anestesista", value:"MedicoAnestesista" },
];

export { TipoCadastroCorpoClinicoOptions};
